import initialState from './initialState';
import {
  FETCH_CURRENCY_CONVERSION_RATES,
  FETCH_CURRENCY_CONVERSION_RATES_SUCCESS,
  FETCH_CURRENCY_CONVERSION_RATES_FAILURE,
  SAVE_CURRENCY_CONVERSION_RATE,
  SAVE_CURRENCY_CONVERSION_RATE_SUCCESS,
  SAVE_CURRENCY_CONVERSION_RATE_FAILURE,
  UPLOADING_CURRENCY_CONVERSION_RATES,
  UPLOADING_CURRENCY_CONVERSION_RATES_SUCCESS,
  UPLOADING_CURRENCY_CONVERSION_RATES_FAILURE,
  IMPORT_CURRENCY_CONVERSION_RATES,
  IMPORT_CURRENCY_CONVERSION_RATES_SUCCESS,
  IMPORT_CURRENCY_CONVERSION_RATES_FAILURE,
  CALCULATE_MISSING_RATES,
  IMPORT_CURRENCY_CONVERSION_RATES_PROGRESS,
  REMOVE_CURRENCY_CONVERSION_RATE,
  REMOVE_CURRENCY_CONVERSION_RATE_SUCCESS,
  REMOVE_CURRENCY_CONVERSION_RATE_FAILURE,
  CLEAR_UPLOADED_RATES,
} from './types';

function connectionSettings(state = initialState, action) {
  switch (action.type) {
    case FETCH_CURRENCY_CONVERSION_RATES:
      return {
        ...state,
        fetchingCurrencyConversionRates: true,
        extendedUploadedCurrencyConversionRates: initialState.extendedUploadedCurrencyConversionRates,
        missingRates: initialState.missingRates,
      };
    case FETCH_CURRENCY_CONVERSION_RATES_SUCCESS:
      return {
        ...state,
        fetchingCurrencyConversionRates: false,
        currencyConversionRates: action.currencyConversionRates,
        currencyOptions: action.currencyOptions,
      };
    case FETCH_CURRENCY_CONVERSION_RATES_FAILURE:
      return {
        ...state,
        fetchingCurrencyConversionRates: false,
      };
    case SAVE_CURRENCY_CONVERSION_RATE:
      return {
        ...state,
        isSavingInProgress: true,
      };
    case SAVE_CURRENCY_CONVERSION_RATE_SUCCESS:
      return {
        ...state,
        isSavingInProgress: false,
      };
    case SAVE_CURRENCY_CONVERSION_RATE_FAILURE:
      return {
        ...state,
        isSavingInProgress: false,
      };
    case REMOVE_CURRENCY_CONVERSION_RATE:
      return {
        ...state,
        isRemovingInProgress: true,
      };
    case REMOVE_CURRENCY_CONVERSION_RATE_SUCCESS:
    case REMOVE_CURRENCY_CONVERSION_RATE_FAILURE:
      return {
        ...state,
        isRemovingInProgress: false,
      };
    case UPLOADING_CURRENCY_CONVERSION_RATES:
      return {
        ...state,
        uploadingCurrencyConversionRates: true,
      };
    case UPLOADING_CURRENCY_CONVERSION_RATES_SUCCESS:
      return {
        ...state,
        uploadingCurrencyConversionRates: false,
        extendedUploadedCurrencyConversionRates: action.extendedUploadedCurrencyConversionRates,
        importStats: action.importStats,
      };
    case UPLOADING_CURRENCY_CONVERSION_RATES_FAILURE:
      return {
        ...state,
        uploadingCurrencyConversionRates: false,
      };
    case IMPORT_CURRENCY_CONVERSION_RATES:
      return {
        ...state,
        importingCurrencyConversionRates: true,
      };
    case IMPORT_CURRENCY_CONVERSION_RATES_SUCCESS:
      return {
        ...state,
        importingCurrencyConversionRates: false,
        extendedUploadedCurrencyConversionRates: [],
      };
    case IMPORT_CURRENCY_CONVERSION_RATES_FAILURE:
      return {
        ...state,
        importingCurrencyConversionRates: false,
      };
    case IMPORT_CURRENCY_CONVERSION_RATES_PROGRESS:
      return {
        ...state,
        importingCurrencyConversionRatesProgress: action.progress,
      };
    case CALCULATE_MISSING_RATES:
      return {
        ...state,
        missingRates: action.missingRates,
      };
    case CLEAR_UPLOADED_RATES:
      return {
        ...state,
        extendedUploadedCurrencyConversionRates: [],
        missingRates: [],
      };
    default:
      return state;
  }
}

export default connectionSettings;
